
import { Component, mixins, namespace } from 'nuxt-property-decorator';
import FourwavesLogoFull from 'fourwaves-shared/src/images/fourwaves-dark-full.png';
import { FeatureFlag, Role } from 'fourwaves-shared';
import OrganizationDropdown from '../dropdown/OrganizationDropdown.vue';
import MobileNav from '../MobileNav.vue';
import { OrganizationMixin } from '~/mixins';
import OrganizationPlanAlert from '~/components/organization/OrganizationPlanAlert.vue';
import UpgradeButton from '~/components/upgrade/UpgradeButton.vue';

const SettingsModule = namespace('settings');

@Component({
  components: {
    OrganizationDropdown,
    MobileNav,
    OrganizationPlanAlert,
    UpgradeButton,
  },
})
export default class OrganizationNavPanel extends mixins(OrganizationMixin) {
  @SettingsModule.Getter readonly hasOrganizationRole!: (organizationId: string, roleName: string) => boolean;
  readonly FourwavesLogoFull = FourwavesLogoFull;
  readonly FeatureFlag = FeatureFlag;

  get organizationName(): string {
    if (!this.organization) return '';
    return this.transl8(this.organization.name);
  }

  get isAdministrator(): boolean {
    if (!this.organization) return false;
    return this.hasOrganizationRole(this.organization.id, Role.Administrator);
  }
}
